import Icon from '@/components/ui/AppIcon';

interface CTASectionProps {
  onStartJourney: () => void;
}

const CTASection = ({ onStartJourney }: CTASectionProps) => {
  return (
    <section className="py-16 md:py-24 px-4 bg-gradient-to-br from-primary/10 via-background to-accent/10">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-text-primary mb-6 leading-tight">
          Ready to Transform Your <span className="text-primary">Wellness Journey</span>?
        </h2>
        
        <p className="text-lg md:text-xl text-text-secondary mb-8 md:mb-12 max-w-2xl mx-auto leading-relaxed">
          Start your personalized wellness conversation today. No commitments, no pressure—just supportive guidance tailored to you.
        </p>

        <button
          onClick={onStartJourney}
          className="group inline-flex items-center gap-3 px-8 py-4 md:px-10 md:py-5 bg-primary text-primary-foreground rounded-lg text-lg md:text-xl font-semibold shadow-soft-lg hover:shadow-soft-xl transition-smooth focus-ring touch-target"
        >
          Begin Your Journey Now
          <Icon 
            name="ArrowRightIcon" 
            size={24} 
            className="group-hover:translate-x-1 transition-smooth" 
          />
        </button>

        <p className="mt-6 text-sm text-text-secondary">
          Free to start • No credit card required • Privacy protected
        </p>
      </div>
    </section>
  );
};

export default CTASection;